import type { ReactNode } from "react";

interface ViewerBarProps {
  /** Who the page is being viewed as. */
  children: ReactNode;
  /** The way out of that choice ("Not you?"). */
  actionLabel: string;
  onAction: () => void;
}

/** The line at the top of Home saying how it's being viewed, with a button to change that. */
export function ViewerBar({ children, actionLabel, onAction }: ViewerBarProps) {
  return (
    <div className="home-me">
      <span>{children}</span>
      <button type="button" className="home-me__forget" onClick={onAction}>
        {actionLabel}
      </button>
    </div>
  );
}
